export class AppConfig{
    public backendUrl:string;
    public authUrl:string;
    public env:string = '';
    public logoPath:string;
    public bannerPath:string;
    public testingMode:boolean;
    public AccessCodeExpiry:string ="30";
    public ProductId:any =89;
    public CompanyBranchId:any =1018;
    public OTACTemplateId:any =3182;
    public accessKey:string ="d4c9b8b202a4e32e445605904ac3f4ca";
    public LandingPageUrl:string = "https://rac.samba.com.pk"
}